import { render, staticRenderFns } from "./Section17.vue?vue&type=template&id=36bcd594&"
import script from "./Section17.vue?vue&type=script&lang=js&"
export * from "./Section17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports